import React, {useEffect, useState, useRef, useContext} from "react";
import OlMap from 'ol/Map';
import OlView from 'ol/View';
import {TileWMS, Vector as VectorSource, Cluster, XYZ, OSM} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer, Group as LayerGroup} from 'ol/layer';
import OlProj from 'ol/proj/Projection';
import OlFormatGeoJSON from 'ol/format/GeoJSON';
import {format} from 'ol/coordinate';
import OlLayerGroup from 'ol/layer/Group';
import LayerSidebar from '../../components/LayerSidebar';
import {LayerTree} from '@terrestris/react-geo';
import {Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style';
import { config } from '../../config';
import { authenticationService, bicycleParkingService, surveyService } from '../../services';
import Sidebar from '../../components/Sidebar'
import Rulebook from "../../components/Rulebook";

import UpdatePassword from "../../components/User/UpdatePassword";

import BicycleParkingSpotInfo from "../../components/BicycleParkingSpotInfo";

import { Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch ,Tabs,Checkbox} from 'antd';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Role, useInterval,reverseGeocode} from '../../helpers';
import "cropperjs/dist/cropper.min.css";
import AppHeading from "../../components/AppHeading";
import MunicipalitySearch from "../../components/MunicipalitySearch";

import 'moment/locale/hr';
import 'ol/ol.css';

import './Analytics.css';

import {
    MapComponent,
	ToggleGroup,
} from '@terrestris/react-geo';

import NavbarButton from "../../components/NavbarButton";
import { UserContext } from "../../contexts/UserContext";
import {locateMe} from "../../helpers/locationHelper";
import {exportToShapeFile} from "../../helpers/exportToShapeFileHelper"
import AppSidebar from "../../components/AppSidebar";


import obrnuti_u from './images/icons/withouth_marker/obrnuti_u_v6.png'

import AnalyticsDashboard from "../../components/AnalyticsDashboard";
import AdministrationInterface from "../../components/AdministrationInterface/AdministrationInterface";
import { createWMSLayer, getWmtsGwcLayer, createPointLayer, createClusterLayer, createHeatMap, setHeatMap, createClusterTrendlayer, HtrsExtents } from "../../helpers/mapHelpers";
import { Model } from "survey-react";
import niski_resetkasti from './images/icons/withouth_marker/niski_resetkasti.png'
import niski_spiralni from './images/icons/withouth_marker/niski_spiralni.png'
import skloniste from './images/icons/withouth_marker/skloniste.png'
import parkirna_konstrukcija from './images/icons/withouth_marker/parkirna_konstrukcija.png'
import punionica_za_e from './images/icons/withouth_marker/e_punionica.png'
import stupicasti from './images/icons/withouth_marker/stupicasti_stalak.png'
import utor from './images/icons/withouth_marker/utor_za_kotac.png'
import visoki_resetkasti from './images/icons/withouth_marker/visoki_resetkasti.png'
import visoki_spiralni from './images/icons/withouth_marker/visoki_spiralni.png'
import zidni from './images/icons/withouth_marker/zidni_nosac.png'
import valoviti from './images/icons/withouth_marker/valoviti_stalak.png'
import stalak_za_romobile from './images/icons/withouth_marker/stalak_za_romobile.png'

import romobil_potraznja from './images/icons/withouth_marker/romobil_potraznja.png'
import bicikl_potraznja from './images/icons/withouth_marker/bicikl_potraznja.png'
import ponuda from './images/icons/ponuda.png'
import potraznja from './images/icons/potraznja.png'
import { useHistory } from "react-router-dom";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import MunicipalitySearchMobile from "../../components/MunicipalitySearchMobile";
import Permission from "../../components/Permission";
import Roles from "../../components/Permission/Roles";
//import MapComponent from "../../components/Map";
import SurveyAnsweredCount from "../../components/SurveyAnsweredCount/SurveyAnsweredCount";
import { toLonLat, transform } from "ol/proj";
const { TabPane } = Tabs;


const { Option } = Select;

const heatMap = createHeatMap('ciklopark:heatmap', 'Toplinska karta - ponuda i potražnja', feature => (feature.get('weight')), ['#f00', '#ff0', '#0f0']);
heatMap.setVisible(false);
const heatMap_demand = createHeatMap('ciklopark:bicycle_parking_demand_user', 'Toplinska karta - potražnja', feature => 1, ['#ff0', '#f00']);
heatMap_demand.setOpacity(.5);
heatMap_demand.setVisible(false);
const heatMap_supply= createHeatMap('ciklopark:bicycle_parking_supply_user', 'Toplinska karta - ponuda', feature => 0.5, ['#ff0', '#0f0']);
heatMap_supply.setVisible(false);
const clusterHeatMap = createClusterTrendlayer('ciklopark:heatmap', 'Toplinska karta - ponuda i potražnja - grupirano');

const bicycle_parking_jls_supply_and_demand = createClusterLayer('ciklopark:jls_suply_demand', 'Apsolutne vrijednosti');
const bicycle_parking_supply_obrnuti_u = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Obrnuti U stalak za bicikle – „klamerica“', [obrnuti_u, 1], 'type',false,'obrnuti_U');
const bicycle_parking_supply_niski_resetkasti = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Niski rešetkasti stalak za bicikle – niska „rešetka“', [obrnuti_u, 1], 'type',false,'niski_resetkasti');
const bicycle_parking_supply_visoki_resetkasti = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Visoki rešetkasti stalak za bicikle – visoka „rešetka“', [obrnuti_u, 1], 'type',false,'visoki_resetkasti');
const bicycle_parking_supply_niski_spiralni = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Niski spiralni stalak za bicikle – niska „spirala“', [obrnuti_u, 1], 'type',false,'niski_spiralni');
const bicycle_parking_supply_visoki_spiralni = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Visoki spiralni stalak za bicikle – visoka  „spirala“', [obrnuti_u, 1], 'type',false,'visoki_spiralni');
const bicycle_parking_supply_valoviti_stalak = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Valoviti stalak za bicikle – „val“', [obrnuti_u, 1], 'type',false,'valoviti_stalak');
const bicycle_parking_supply_stupcasti_stalak = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Stupčasti stalak za bicikle – „stup“', [obrnuti_u, 1], 'type',false,'stupcasti_stalak');
const bicycle_parking_supply_zidni_nosac = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Zidni nosač', [obrnuti_u, 1], 'type',false,'zidni_nosac');
const bicycle_parking_supply_utor = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Utor za kotač bicikla', [obrnuti_u, 1], 'type',false,'utor_za');
const bicycle_parking_supply_ormar = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Ormar za pohranu bicikala – „bike box“', [obrnuti_u, 1], 'type',false,'ormar_za');
const bicycle_parking_supply_parkirna_konstrukcija = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Parkirna konstrukcija u razinama', [obrnuti_u, 1], 'type',false,'parkirna_konstrukcija');
const bicycle_parking_supply_punionica = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Punionica za e-bicikle', [obrnuti_u, 1], 'type',false,'punionica_za');
const bicycle_parking_supply_romobil = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Stalak za romobile', [obrnuti_u, 1], 'type',false,'stalak_za');
const bicycle_parking_demand_bicycle_existing = createPointLayer('ciklopark:bicycle_parking_demand_user', 'Bicikli', [obrnuti_u, 1], 'type',false,'bicikl - Potražnja za postojećim stalkom na lokaciji');
const bicycle_parking_demand_scooter_existing = createPointLayer('ciklopark:bicycle_parking_demand_user', 'Romobili', [obrnuti_u, 1], 'type',false,'romobil - Potražnja za postojećim stalkom na lokaciji');

const bicycle_parking_demand_bicycle_alternative = createPointLayer('ciklopark:bicycle_parking_demand_user', 'Bicikli', [obrnuti_u, 1], 'type',false,'bicikl - Alternativna potražnja (zbog neadekvatnosti ili nepostojanja stalka na lokaciji), primjer bicikl: bicikl pričvršćen za drvo, znak, ogradu..');
const bicycle_parking_demand_scooter_alternative = createPointLayer('ciklopark:bicycle_parking_demand_user', 'Romobili', [obrnuti_u, 1], 'type',false,'romobil - Alternativna potražnja (zbog neadekvatnosti ili nepostojanja stalka na lokaciji), primjer bicikl: bicikl pričvršćen za drvo, znak, ogradu..');
const bicycle_parking_supply = createPointLayer('ciklopark:bicycle_parking_supply_user', 'Parkirališna ponuda', [obrnuti_u, 1], 'type');
const bicycle_parking_demand = createPointLayer('ciklopark:bicycle_parking_demand_user', 'Parkirališna potražnja', [obrnuti_u, 1], 'type');
const JLS = createWMSLayer('JLS','ciklopark:geo_jls_group', true);

const mercProj = new OlProj({
	code: "EPSG:900913"
})
//var RPJ_POPULATION_NUMBER_WMS_2021 = createWMSLayer('Prostorni raspored stanovništva','ciklopark:prostorni_raspored_stanovnistva_2021', false);
var RPJ_POPULATION_NUMBER_2021 = getWmtsGwcLayer('Prostorni raspored stanovništva','ciklopark:prostorni_raspored_stanovnistva_2021', false,true);

const osm = new TileLayer({ 
  name: 'Open Street Map',
  visible: true,
  source: new OSM({attributions: '<a class="copyright" href="https://www.openstreetmap.org/copyright" target="_blank">OSM</a>'}),
  zIndex:0
});

const hoverLayer = new VectorLayer({
	name: 'HoverLines',
	source: new VectorSource(),
	style: new Style({
		stroke: new Stroke({
			color: 'red',
			width: 4,
			lineCap : 'square',
			lineJoin: 'bevel'
		})
	}),
	zIndex: 25,
	metadata: "hover"
});

function selectStyleFunction(feature, resolution) {
	let style;
	if (feature.getGeometry().getType() == 'Point') {
		let symbol = feature.get('symbolDefinition');
		if (Array.isArray(symbol)){
			style = new Style({
				image: new Icon({
					crossOrigin: 'anonymous',
					//imgSize: [20, 20],
					src:symbol[0],
					scale: symbol[1],				
					color:'yellow',
					anchor: [0.5, 1],
          			anchorXUnits: 'fraction',
          			anchorYUnits: 'fraction',
				}),
			});
		}
	} else {
		//MultiLineString
		style = new Style({
			stroke: new Stroke({
				color: 'yellow',
				width: 4,
				lineCap : 'square',
				lineJoin: 'bevel',
				anchor: [0.5, 1],
          		anchorXUnits: 'fraction',
          		anchorYUnits: 'fraction',
			}),
		});
	}
	return style;
}

const selectLayer = new VectorLayer({
	name: 'SelectLines',
	source: new VectorSource(),
	style: selectStyleFunction,
	zIndex: 32,//26,
	metadata: "select"
});

const extents=HtrsExtents();
const centerCoordinates = [(extents[0]+extents[2])/2,(extents[1]+extents[3])/2];

export const Analytics = (props) => {
	const { location: userLocation } = useContext(UserContext)
	const {setLocation} = useContext(UserContext)
	const history = useHistory()
	
	// Utility
	const [showImageVisible, setShowImageVisible] = useState(false);
	const [exportSidebarVisible, setExportSidebarVisible]= useState(false);
	const [legendSidebarVisible, setLegendSidebarVisible] = useState(false);
	const [showBicycleParkingVisible, setShowBicycleParkingVisible] = useState(false);
	const [isFetchingSourceData, setIsFetchingSourceData] = useState(true);
	const [analyticsSidebarVisible, setAnalyticsSidebarVisible] = useState(false);
	const [maskDrawerInfo, setMaskDrawerInfo] = useState(true);
	const [spatialRegistrySidebarVisible, setSpatialRegistrySidebarVisible] = useState(false);
	const [administrationInterfaceModalVisible,setAdministrationInterfaceModalVisible] = useState(false);
	const [rulebookVisible,setRulebookVisible]=useState(false)
	const [surveyAnsweredCountVisible, setSurveyAnsweredCountVisible] = useState(false);
	const key = 'updatable';

	const [currentImages, setCurrentImages] = useState(false);
	const [loading, setLoading] = useState(false);

	// Data
	const [selectedBicycleParkingSpot, setSelectedBicycleParkingSpot] = useState(null);
 
	// Sources
	const sourceHover = hoverLayer.getSource();
	const sourceSelect = selectLayer.getSource();
	
	const sourceBicycleParking_supply_obrnuti_u = bicycle_parking_supply_obrnuti_u.getSource();
	const sourceBicycleParking_supply_niski_resetkasti = bicycle_parking_supply_niski_resetkasti.getSource();
	const sourceBicycleParking_supply_visoki_resetkasti = bicycle_parking_supply_visoki_resetkasti.getSource();
	const sourceBicycleParking_supply_niski_spiralni = bicycle_parking_supply_niski_spiralni.getSource();
	const sourceBicycleParking_supply_visoki_spiralni = bicycle_parking_supply_visoki_spiralni.getSource();
	const sourceBicycleParking_supply_valoviti_stalak = bicycle_parking_supply_valoviti_stalak.getSource();
	const sourceBicycleParking_supply_stupcasti_stalak = bicycle_parking_supply_stupcasti_stalak.getSource();
	const sourceBicycleParking_supply_zidni_nosac = bicycle_parking_supply_zidni_nosac.getSource();
	const sourceBicycleParking_supply_utor = bicycle_parking_supply_utor.getSource();
	const sourceBicycleParking_supply_ormar = bicycle_parking_supply_ormar.getSource();
	const sourceBicycleParking_supply_parkirna_konstrukcija = bicycle_parking_supply_parkirna_konstrukcija.getSource();
	const sourceBicycleParking_supply_punionica = bicycle_parking_supply_punionica.getSource();
	const sourceBicycleParking_supply_romobil = bicycle_parking_supply_romobil.getSource();

	const sourceBicycleParking_supply = bicycle_parking_supply.getSource();

	const sourceBicycleParking_demand = bicycle_parking_demand.getSource();

	const sourceBicycleParking_demand_bicycle_existing = bicycle_parking_demand_bicycle_existing.getSource();
	const sourceBicycleParking_demand_scooter_existing = bicycle_parking_demand_scooter_existing.getSource();
	const sourceBicycleParking_demand_bicycle_alternative = bicycle_parking_demand_bicycle_alternative.getSource();
	const sourceBicycleParking_demand_scooter_alternative = bicycle_parking_demand_scooter_alternative.getSource();

	// Features
	const [featuresBicycleParking_supply_obrnuti_u, setFeaturesBicycleParking_supply_obrnuti_u] = useState(null);
	const [featuresBicycleParking_supply_niski_resetkasti, setFeaturesBicycleParking_supply_niski_resetkasti] = useState(null);
	const [featuresBicycleParking_supply_visoki_resetkasti , setFeaturesBicycleParking_supply_visoki_resetkasti ] = useState(null);
	const [featuresBicycleParking_supply_niski_spiralni, setFeaturesBicycleParking_supply_niski_spiralni] = useState(null);
	const [featuresBicycleParking_supply_visoki_spiralni, setFeaturesBicycleParking_supply_visoki_spiralni] = useState(null);
	const [featuresBicycleParking_supply_valoviti_stalak, setFeaturesBicycleParking_supply_valoviti_stalak] = useState(null);
	const [featuresBicycleParking_supply_stupcasti_stalak, setFeaturesBicycleParking_supply_stupcasti_stalak] = useState(null);
	const [featuresBicycleParking_supply_zidni_nosac, setFeaturesBicycleParking_supply_zidni_nosac] = useState(null);
	const [featuresBicycleParking_supply_utor, setFeaturesBicycleParking_supply_utor] = useState(null);
	const [featuresBicycleParking_supply_ormar, setFeaturesBicycleParking_supply_ormar] = useState(null);
	const [featuresBicycleParking_supply_parkirna_konstrukcija, setFeaturesBicycleParking_supply_parkirna_konstrukcija] = useState(null);
	const [featuresBicycleParking_supply_punionica, setFeaturesBicycleParking_supply_punionica] = useState(null);
	const [featuresBicycleParking_supply_romobil, setFeaturesBicycleParking_supply_romobil] = useState(null);

	const [featuresBicycleParking_supply, setFeaturesBicycleParking_supply] = useState(null);
	const [featuresBicycleParking_demand, setFeaturesBicycleParking_demand] = useState(null);



	const [featuresBicycleParking_demand_bicycle_existing, setFeaturesBicycleParking_demand_bicycle_existing] = useState(null);
	const [featuresBicycleParking_demand_scooter_existing, setFeaturesBicycleParking_demand_scooter_existing] = useState(null);

	const [featuresBicycleParking_demand_bicycle_alternative, setFeaturesBicycleParking_demand_bicycle_alternative] = useState(null);
	const [featuresBicycleParking_demand_scooter_alternative, setFeaturesBicycleParking_demand_scooter_alternative] = useState(null);


	const [imageToPrint, setImageToPrint] = useState(null)
	const [showPrintVisible, setShowPrintVisible] = useState(false);
	// Refs
	const [form] = Form.useForm();
	const mapRef = useRef();
	//const dofRef = useRef();
	const drawRef = useRef();
	const sketchRef = useRef();
	const listenerRef = useRef(); 

	const [showAnalyticsDashboard, setShowAnalyticsDashboard] = useState(false)
	const size = useWindowDimensions()

	const transactionId=useRef(null)
	const showLocator = useRef(false)
	const [mapMoving, setMapMoving] = useState(false)
	// Slojevi
	const RegisterGroupTiles = new OlLayerGroup({
		name: 'Registar prostornih jedinica',
		layers: [
				JLS
		].filter(n => n)
	});



	//setVisibility(false)
	const layerGroupTiles = new OlLayerGroup({
		name: 'LayerGroupTiles',
		layers: [
			RegisterGroupTiles,
		]
	});

	//Kartografske podloge
	const publicGroupTiles = new OlLayerGroup({
		name: 'Javne',
		layers: [
			osm
		].filter(n => n)
	});
/* dok se geo ne slozi	
	const officialGroupTiles = new OlLayerGroup({
		name: 'Službene',
		layers:[
			new OlLayerGroup({
				name:'DOF5_2019_2020',
				layers: [
					DOF5_2019_2020,
					DOF5_2011_FILL_2019_2020]
			})
		].filter(n => n)
	});
*/
	const mapGroupTiles = new OlLayerGroup({
		name: 'MapGroupTiles',
		layers: [
			publicGroupTiles,
			// dok se geo ne slozi	officialGroupTiles
		].filter(n => n)
	});

	
	
	const supplyAndDemandHeatLayers = new OlLayerGroup({
		name: 'Omjer ponude i potražnje',
		layers: [
			clusterHeatMap,
			heatMap,
			heatMap_demand,
			heatMap_supply,			
			bicycle_parking_jls_supply_and_demand,
		].filter(n => n)
	});
	

	let groupLines
	if(JSON.parse(localStorage.getItem("ciklopark_current_user"))?.type>0&&JSON.parse(localStorage.getItem("ciklopark_current_user"))?.type<5){
	groupLines = new OlLayerGroup({
		name: 'Parkirna mjesta',
		layers: [
			
			supplyAndDemandHeatLayers.getLayers().getArray().length > 0 && supplyAndDemandHeatLayers,	
			
			
			new OlLayerGroup({
				name:'Parkirališna ponuda',
				layers: [
					bicycle_parking_supply_romobil,
					bicycle_parking_supply_punionica,
					bicycle_parking_supply_parkirna_konstrukcija,
					bicycle_parking_supply_ormar,
					bicycle_parking_supply_utor,
					bicycle_parking_supply_zidni_nosac,
					bicycle_parking_supply_stupcasti_stalak,
					bicycle_parking_supply_valoviti_stalak,
					bicycle_parking_supply_visoki_spiralni,
					bicycle_parking_supply_niski_spiralni,
					bicycle_parking_supply_visoki_resetkasti,
					bicycle_parking_supply_niski_resetkasti,
					bicycle_parking_supply_obrnuti_u
				]
			}),
			new OlLayerGroup({
				name:'Parkirališna potražnja',
				layers: [
					new OlLayerGroup({
						name:'Alternativna potražnja',
						layers: [
							bicycle_parking_demand_scooter_alternative,
							bicycle_parking_demand_bicycle_alternative,							
						]
					}),
					new OlLayerGroup({
						name:'Postojeći stalci',
						layers: [
							bicycle_parking_demand_scooter_existing,
							bicycle_parking_demand_bicycle_existing,							
						]
					}),					
				]
			}),
			RPJ_POPULATION_NUMBER_2021,
		].filter(n => n)
	});
}
else{
	groupLines = new OlLayerGroup({
		name: 'Parkirna mjesta',
		layers: [
			supplyAndDemandHeatLayers.getLayers().getArray().length > 0 && supplyAndDemandHeatLayers,
			bicycle_parking_demand,		
			bicycle_parking_supply,
			RPJ_POPULATION_NUMBER_2021,
		].filter(n => n)
	});

}


	const proj = new OlProj({
		code: 'EPSG:3765',
		units: 'm',
		global: false
	});
	

	const mapLayers = [
		mapGroupTiles,
		layerGroupTiles,
		groupLines,
		hoverLayer,
		selectLayer,
	]

	const map = new OlMap({
        view: new OlView({
			center: centerCoordinates,//[498134, 4925214],
			projection: proj,
			zoom: 8,
			enableRotation: false,
        	maxZoom: 24,
       		minZoom: 7
        }),
        layers: mapLayers
	});

	//apply(map, 'https://api.maptiler.com/maps/basic-v2/style.json?key=PXozRJubuZMcE1tHsdVw');
	
	useEffect(() => {
		
		if(loading) {
			message.loading({ content: 'Učitavanje...', key });
		}
		else {
			message.success({ content: 'Učitano!', key, duration: 2 });
			map.getView().fit(extents,{padding: [100, 10, 10, 10]});
		}
	}, [loading])


	

	// Buffer features
	const checkAndSetFeatures = (features, setFeatures, source) => {
  if (!features || features.length === 0) {
    const data = source.getFeatures();
    if (data && data.length > 0) {
      setFeatures(data);
    }
  }
};

useInterval(() => {
  checkAndSetFeatures(featuresBicycleParking_supply_obrnuti_u, setFeaturesBicycleParking_supply_obrnuti_u, sourceBicycleParking_supply_obrnuti_u);
  checkAndSetFeatures(featuresBicycleParking_supply_niski_resetkasti, setFeaturesBicycleParking_supply_niski_resetkasti, sourceBicycleParking_supply_niski_resetkasti);
  checkAndSetFeatures(featuresBicycleParking_supply_visoki_resetkasti, setFeaturesBicycleParking_supply_visoki_resetkasti, sourceBicycleParking_supply_visoki_resetkasti);
  checkAndSetFeatures(featuresBicycleParking_supply_niski_spiralni, setFeaturesBicycleParking_supply_niski_spiralni, sourceBicycleParking_supply_niski_spiralni);
  checkAndSetFeatures(featuresBicycleParking_supply_visoki_spiralni, setFeaturesBicycleParking_supply_visoki_spiralni, sourceBicycleParking_supply_visoki_spiralni);
  checkAndSetFeatures(featuresBicycleParking_supply_valoviti_stalak, setFeaturesBicycleParking_supply_valoviti_stalak, sourceBicycleParking_supply_valoviti_stalak);
  checkAndSetFeatures(featuresBicycleParking_supply_stupcasti_stalak, setFeaturesBicycleParking_supply_stupcasti_stalak, sourceBicycleParking_supply_stupcasti_stalak);
  checkAndSetFeatures(featuresBicycleParking_supply_zidni_nosac, setFeaturesBicycleParking_supply_zidni_nosac, sourceBicycleParking_supply_zidni_nosac);
  checkAndSetFeatures(featuresBicycleParking_supply_utor, setFeaturesBicycleParking_supply_utor, sourceBicycleParking_supply_utor);
  checkAndSetFeatures(featuresBicycleParking_supply_ormar, setFeaturesBicycleParking_supply_ormar, sourceBicycleParking_supply_ormar);
  checkAndSetFeatures(featuresBicycleParking_supply_parkirna_konstrukcija, setFeaturesBicycleParking_supply_parkirna_konstrukcija, sourceBicycleParking_supply_parkirna_konstrukcija);
  checkAndSetFeatures(featuresBicycleParking_supply_punionica, setFeaturesBicycleParking_supply_punionica, sourceBicycleParking_supply_punionica);
  checkAndSetFeatures(featuresBicycleParking_supply_romobil, setFeaturesBicycleParking_supply_romobil, sourceBicycleParking_supply_romobil);
  checkAndSetFeatures(featuresBicycleParking_demand_bicycle_existing, setFeaturesBicycleParking_demand_bicycle_existing, sourceBicycleParking_demand_bicycle_existing);
  checkAndSetFeatures(featuresBicycleParking_demand_scooter_existing, setFeaturesBicycleParking_demand_scooter_existing, sourceBicycleParking_demand_scooter_existing);
  checkAndSetFeatures(featuresBicycleParking_demand_bicycle_alternative, setFeaturesBicycleParking_demand_bicycle_alternative, sourceBicycleParking_demand_bicycle_alternative);
  checkAndSetFeatures(featuresBicycleParking_demand_scooter_alternative, setFeaturesBicycleParking_demand_scooter_alternative, sourceBicycleParking_demand_scooter_alternative);

  checkAndSetFeatures(featuresBicycleParking_demand, setFeaturesBicycleParking_demand, sourceBicycleParking_demand);
  checkAndSetFeatures(featuresBicycleParking_supply, setFeaturesBicycleParking_supply, sourceBicycleParking_supply);
}, 10000);



	useEffect(() => {
		if(!authenticationService.getUser()) {
			authenticationService.loginAnonymous()
		}		
	}, [])


	// Initial component load
	React.useEffect(() => {
		mapRef.current = map;
		const fetchData = async() => {			
		}
		fetchData();
		refreshAllSources();
	}, [])


	const pointerMoveHandler = (evt) => {
		if (evt.dragging) {
			return;
		}

		sourceHover.clear();
		document.getElementById('MousePosition').innerHTML = format(map.getCoordinateFromPixel(evt.pixel), "{x}, {y}", 2);

		map.getTargetElement().style.cursor = map.hasFeatureAtPixel(evt.pixel) ? 'pointer' : '';

        const hoveredFeatures = map.getFeaturesAtPixel(evt.pixel, {
            layerFilter: function(layer) {
                return [
					bicycle_parking_supply_obrnuti_u,
					bicycle_parking_supply_niski_resetkasti,
					bicycle_parking_supply_visoki_resetkasti, 
					bicycle_parking_supply_niski_spiralni,
					bicycle_parking_supply_visoki_spiralni,
					bicycle_parking_supply_valoviti_stalak,
					bicycle_parking_supply_stupcasti_stalak,
					bicycle_parking_supply_zidni_nosac,
					bicycle_parking_supply_utor,
					bicycle_parking_supply_ormar,
					bicycle_parking_supply_parkirna_konstrukcija,
					bicycle_parking_supply_punionica,
					bicycle_parking_supply_romobil,
					bicycle_parking_demand_bicycle_existing,
					bicycle_parking_demand_scooter_existing,

					bicycle_parking_demand_bicycle_alternative,
					bicycle_parking_demand_scooter_alternative,

					bicycle_parking_supply,
					bicycle_parking_demand,
				].filter(n => n).includes(layer);
            }
		});

		if(hoveredFeatures && hoveredFeatures.length > 0) {
			try {
				for (let i = 0; i < hoveredFeatures.length; i++) {
					sourceHover.addFeature(hoveredFeatures[i]);
				}
			}
			catch {}
		}

	
		//map.updateSize();
	};

	 const handlePrint  = () => {

		mapRef.current.once('rendercomplete', function () {
			const mapCanvas = document.createElement('canvas');
			const size = mapRef.current.getSize();
			mapCanvas.width = size[0];
			mapCanvas.height = size[1];
			const mapContext = mapCanvas.getContext('2d');
			Array.prototype.forEach.call(
			mapRef.current.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
			function (canvas) {
				if (canvas.width > 0) {
				const opacity =
					canvas.parentNode.style.opacity || canvas.style.opacity;
				mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
		
				const backgroundColor = canvas.parentNode.style.backgroundColor;
				if (backgroundColor) {
					mapContext.fillStyle = backgroundColor;
					mapContext.fillRect(0, 0, canvas.width, canvas.height);
				}
		
				let matrix;
				const transform = canvas.style.transform;
				if (transform) {
					// Get the transform parameters from the style's transform matrix
					matrix = transform
					.match(/^matrix\(([^\(]*)\)$/)[1]
					.split(',')
					.map(Number);
				} else {
					matrix = [
					parseFloat(canvas.style.width) / canvas.width,
					0,
					0,
					parseFloat(canvas.style.height) / canvas.height,
					0,
					0,
					];
				}
				// Apply the transform to the export map context
				CanvasRenderingContext2D.prototype.setTransform.apply(
					mapContext,
					matrix
				);
					mapContext.drawImage(canvas, 0, 0);
				}
			}
			);
			if (navigator.msSaveBlob) {
			// link download attribute does not work on MS browsers
				navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
			} else {
	
				setImageToPrint(mapCanvas.toDataURL())
				togglePrintVisible()
			}
		});
		
		mapRef.current.renderSync();
	}

	

	map.on('pointermove', pointerMoveHandler);
	map.on('singleclick', async (e) => {

		setSelectedBicycleParkingSpot(null);
		sourceSelect.clear();
		sourceHover.clear();

        const selectedFeatures = map.getFeaturesAtPixel(e.pixel, {
            layerFilter: function(layer) {
                return [
					bicycle_parking_supply_obrnuti_u,
					bicycle_parking_supply_niski_resetkasti,
					bicycle_parking_supply_visoki_resetkasti, 
					bicycle_parking_supply_niski_spiralni,
					bicycle_parking_supply_visoki_spiralni,
					bicycle_parking_supply_valoviti_stalak,
					bicycle_parking_supply_stupcasti_stalak,
					bicycle_parking_supply_zidni_nosac,
					bicycle_parking_supply_utor,
					bicycle_parking_supply_ormar,
					bicycle_parking_supply_parkirna_konstrukcija,
					bicycle_parking_supply_punionica,
					bicycle_parking_supply_romobil,
					bicycle_parking_demand_bicycle_existing,
					bicycle_parking_demand_scooter_existing,

					bicycle_parking_demand_bicycle_alternative,
					bicycle_parking_demand_scooter_alternative,

					bicycle_parking_supply,
					bicycle_parking_demand,
				].filter(n => n).includes(layer);
            }
		});
		
		setShowBicycleParkingVisible(false);
	    if(selectedFeatures.length > 0) {
            const existingFeatures = selectedFeatures[0].get('features');
				//console.log("Selected features:", selectedFeatures[0].id_)
				console.log(selectedFeatures)
					let bicycleParking = selectedFeatures.map((i)=>
					({id: i.values_['id'], type: i.values_['type'],idcontrols: i.values_['idcontrols'], details: JSON.parse(i.values_['details']),typeOfRequest:i.id_.split('.')[0]}))
					
				if(bicycleParking) {
					setSelectedBicycleParkingSpot(bicycleParking);
					setShowBicycleParkingVisible(true);
					}				
				sourceSelect.addFeature(selectedFeatures[0]);
			
		}
	});
	
	//inicijalno
	setHeatMap (heatMap, map.getView().getZoom());
	//na zoom
	map.getView().on('change:resolution', (event) => {
		setHeatMap (heatMap, map.getView().getZoom());
	});

	const refreshFeature = (source, features) => {
		try {
		  source.refresh();
		  if(source){
			source.readFeatures(features);
		  }
		  source && source.addFeatures(features);
		} catch {}
	  };
	  
	  const refreshAllSources = () => {
		refreshFeature(sourceBicycleParking_supply_obrnuti_u, featuresBicycleParking_supply_obrnuti_u);
		refreshFeature(sourceBicycleParking_supply_niski_resetkasti, featuresBicycleParking_supply_niski_resetkasti);
		refreshFeature(sourceBicycleParking_supply_visoki_resetkasti, featuresBicycleParking_supply_visoki_resetkasti);
		refreshFeature(sourceBicycleParking_supply_niski_spiralni, featuresBicycleParking_supply_niski_spiralni);
		refreshFeature(sourceBicycleParking_supply_visoki_spiralni, featuresBicycleParking_supply_visoki_spiralni);
		refreshFeature(sourceBicycleParking_supply_valoviti_stalak, featuresBicycleParking_supply_valoviti_stalak);
		refreshFeature(sourceBicycleParking_supply_stupcasti_stalak, featuresBicycleParking_supply_stupcasti_stalak);
		refreshFeature(sourceBicycleParking_supply_zidni_nosac, featuresBicycleParking_supply_zidni_nosac);
		refreshFeature(sourceBicycleParking_supply_utor, featuresBicycleParking_supply_utor);
		refreshFeature(sourceBicycleParking_supply_ormar, featuresBicycleParking_supply_ormar);
		refreshFeature(sourceBicycleParking_supply_parkirna_konstrukcija, featuresBicycleParking_supply_parkirna_konstrukcija);
		refreshFeature(sourceBicycleParking_supply_punionica, featuresBicycleParking_supply_punionica);
		refreshFeature(sourceBicycleParking_supply_romobil, featuresBicycleParking_supply_romobil);
		refreshFeature(sourceBicycleParking_demand_bicycle_existing, featuresBicycleParking_demand_bicycle_existing);
		refreshFeature(sourceBicycleParking_demand_scooter_existing, featuresBicycleParking_demand_scooter_existing);
		refreshFeature(sourceBicycleParking_demand_bicycle_alternative, featuresBicycleParking_demand_bicycle_alternative);
		refreshFeature(sourceBicycleParking_demand_scooter_alternative, featuresBicycleParking_demand_scooter_alternative);
		refreshFeature(sourceBicycleParking_demand, featuresBicycleParking_demand);
		refreshFeature(sourceBicycleParking_supply, featuresBicycleParking_supply);
	  };
         
    const resetSidebars = () => {
		setLegendSidebarVisible(false);
		setExportSidebarVisible(false);
		setSpatialRegistrySidebarVisible(false);
		setAnalyticsSidebarVisible(false);

    }

	const toggleShowSpatialRegistry = () => {
		resetSidebars();
		setSpatialRegistrySidebarVisible(!spatialRegistrySidebarVisible);
	}


	const toggleShowExport = () =>{
		resetSidebars();
		setExportSidebarVisible(!exportSidebarVisible);
	}

	const toggleShowAdministrationInterfaceModal = () =>{
		setAdministrationInterfaceModalVisible(!administrationInterfaceModalVisible);
	}

	const toggleShowRulebook = () =>{
		setRulebookVisible(!rulebookVisible);
	}
   
	const toggleShowLegend = () => {
		resetSidebars();
		setLegendSidebarVisible(!legendSidebarVisible);
		
	}

	const toggleShowAnalytics=() => {		
		resetSidebars();
		setAnalyticsSidebarVisible(!analyticsSidebarVisible);
		
	}

	const handleShowImage = (images) => {
		setCurrentImages(images);
		setShowImageVisible(!showImageVisible);
	}

	const bicycleParkingSpotTitle = selectedBicycleParkingSpot && ( 
		
		selectedBicycleParkingSpot[0].type == "ponuda" && <div>Postojeća ponuda</div> ||
		selectedBicycleParkingSpot[0].type == "potražnja" && <div>Postojeća potražnja</div>
	) || "";

	const manuallySetLocation = async (id) =>{
		sourceSelect.clear();	
		showLocator.current = true
		setMapMoving(true)
		transactionId.current=id
		console.log("Moving id:",transactionId)
	}

	map.on('movestart', () => {
		
		setMapMoving(true)
		
	});

	map.on('moveend', () => {
		
		if(map && showLocator.current) {
			const center = transform(
				map.getView().getCenter(),
				map.getView().getProjection(),
				mercProj
			)
			const latLong = toLonLat(center)
			reverseGeocode({latitude: latLong[1], longitude: latLong[0]}, setLocation)
		}
		setMapMoving(false)}
	);
	
	const updateGeom = async () =>{
		console.log("Updating geom")
		await surveyService.updateGeom({
			longitude: userLocation.coords.longitude,
			latitude: userLocation.coords.latitude,
			id:transactionId.current,
		})
		refreshAllSources()

	}
	const closeGeomUpdateWindow=() =>{
		showLocator.current=false
		setMapMoving(true)
		setMapMoving(false)
		setMapMoving(true)
	}

	const togglePrintVisible = () =>  {
		setShowPrintVisible(!showPrintVisible)
	}
	
	const handlePrintSubmit  = () =>  {
		window.print()
	}
	const showLocation =() =>{
		locateMe(map,mapRef,sourceSelect,setLocation)
	}

	function showLoginButton (){
		const ciklopark_current_user = JSON.parse(localStorage.getItem("ciklopark_current_user"));
		let showLogin=false

		
		if(ciklopark_current_user&&!ciklopark_current_user.name|| !ciklopark_current_user){
			showLogin=true
		}		
		else{
			showLogin=false
		}	 
	 
	  return showLogin
	};


	function showLogoutButton (){
		const ciklopark_current_user = JSON.parse(localStorage.getItem("ciklopark_current_user"));
		let showLogout=false
		
		
		if(ciklopark_current_user&&ciklopark_current_user.name){
			 showLogout=true
		}
		else{
			 showLogout=false
		}	 
	
	  return showLogout
	};



	const toggleShowAnalyticsDashboard = () => {
		setShowAnalyticsDashboard(!showAnalyticsDashboard)
		
		//document.getElementById('MousePosition').innerHTML = format(map.getCoordinateFromPixel(evt.pixel), "{x}, {y}", 2);
	}

	const toggleShowSurveyAnsweredCount = () => {
		setSurveyAnsweredCountVisible(!surveyAnsweredCountVisible)		
	}


	const handleSelectMunicipality = (val) => {
			//setLoading(true);
			if(val){
			const url = `${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
			'typeName=ciklopark:geo_jls&outputFormat=application/json' +
			`&CQL_FILTER=(id='${val.id-21}')`;
		
				fetch(url).then(response => response.json()).then(json => {
					
					const features = new OlFormatGeoJSON().readFeatures(json);
					const feature = features?.filter(f => f.values_["id"] == val.id-21)
					if(feature && feature.length) {
						mapRef.current.getView().fit(feature[0].getGeometry(),{padding: [10, 10, 10, 10]});
					}
				})
			}	
			else{
			console.log("Cleared search")

			}
			
			// temp fix await getRoutes({routeTypes: null, elementTypes: null, locations: null, page: 1, take: 10});

	}
	const toggleShowBicycleParkingSpotInfo = () => {
		setShowBicycleParkingVisible(!showBicycleParkingVisible)
	}

    return (
        <>
			{/*<MapComponent layers={mapLayers} onSetMap={(map) => mapRef.current = map} /> */}
			
            <MapComponent
				map={map}
				ref={mapRef}
            />

			<AppHeading 
				title="Nacionalna baza biciklističke parkirališne ponude i potražnje"
				hasLogin={showLoginButton()}
				hasLogout={showLogoutButton()}
				hasSurveyVerificationCounter={true}
				 
			/>


			{size.width > 560 && <MunicipalitySearch onSelect={handleSelectMunicipality} /> || <MunicipalitySearchMobile onSelect={handleSelectMunicipality} /> }


			<div id = "MousePosition" style={{position: 'fixed', bottom: 2, right: 50, color: 'black'}}></div>
			
            <AppSidebar>            
				<NavbarButton 
					title="Slojevi" 
					icon="ri-stack-fill" 
					content={
						<>
						<LayerTree map={map} layerGroup={groupLines}  />
						</>
					} 
				/>
				<Permission roles={[Roles.Admin,Roles.Verifikator,Roles.Sponzor,Roles.JLSPaid]}>
				<NavbarButton 
					title="Izvoz u Shapefile" 
					content={
						<div className="sidebar-content">
							<Form name="eksport" style={{marginBottom:'1rem'}}>						
								<Checkbox type="checkbox" name="layer" value="ciklopark:bicycle_parking_supply_export_by_jls">Ponuda</Checkbox>
								<Checkbox type="checkbox" name="layer" value="ciklopark:bicycle_parking_demand_export_by_jls">Potražnja</Checkbox>
							</Form>
							<ToggleGroup>
								<Button style={{marginBottom:'5px'}} type={"primary"} onClick={() => {
									const list = document.querySelectorAll("input[name='layer']:checked");
									
									if (list.length != 0) {
										const layers = [];
										for(let value of list.values()) {
											layers.push(value.value);
										}

										const date = new Date();
										const str = date.getFullYear() + "_" + (date.getMonth() + 1) + "_" + date.getDate() + "_" +  date.getHours() + "_" + date.getMinutes() + "_" + date.getSeconds();
										exportToShapeFile('SHP_Export_'+ str, layers);							
									}							
								}}>Izvoz u datoteku</Button>
							</ToggleGroup>
						</div>
					}
					icon="ri-file-download-fill" 
				/>
				</Permission>
				<Permission roles={[Roles.Stanovnici]}>
				<NavbarButton 
				title="Izvoz u Shapefile" 
					
				content={
					<p>Funkcija dostupna uz prijavu</p>
				}
			
				icon="ri-file-download-fill" 
				/>
				</Permission>

				<Permission roles={[Roles.JLSTrial]}>
				<NavbarButton 
				title="Izvoz u Shapefile" 
					
				content={
					<p>Potreban ugovoren račun</p>
				}
			
				icon="ri-file-download-fill" 
				/>
				</Permission>
			
			
				<NavbarButton title="Ispis" onClick={handlePrint} icon="ri-printer-fill" />
				{/* maknuto dok se ne slozi da ispravno radi na racunalu 
				<NavbarButton title="Lociraj me" onClick={showLocation} icon="ri-map-pin-fill" />
				*/}
				<NavbarButton title="Legenda" onClick={toggleShowLegend} icon="ri-information-fill" /> 	
				{/*<NavbarButton title="Statistika" onClick={toggleShowAnalytics} icon="ri-bar-chart-fill" />*/}
				<NavbarButton title="Analitika" onClick={toggleShowAnalyticsDashboard} icon="ri-line-chart-fill" /> 
				{/* <NavbarButton title="Izvještaji" onClick={() => window.open('/app/nationaldatabase/export/','print','width=1080,height=1000')} icon="ri-folder-chart-fill" />  */}
				 <Permission roles={[Roles.Admin, Roles.JLSPaid]}>  
					<NavbarButton title="Izvještaji" onClick={() => history.push('/app/nationaldatabase/export/')} icon="ri-folder-chart-fill" />
				 </Permission> 
				<NavbarButton title="Pravilnik" onClick={toggleShowRulebook} icon="ri-file-list-3-fill" /> 
					
				<Permission roles={[Roles.Admin,Roles.Verifikator]}>
				<NavbarButton title="Semafor" icon="ri-survey-fill" onClick={toggleShowSurveyAnsweredCount}/>
				</Permission>
				<Permission roles={[Roles.Admin,Roles.Verifikator]}>
				<NavbarButton title="Admin sučelje" onClick={toggleShowAdministrationInterfaceModal} style={{color:'green'}}icon="ri-admin-line" />	
				</Permission>
            </AppSidebar>


		
			
			<Modal
                visible={legendSidebarVisible} 
                onClose={toggleShowLegend}
				onCancel={toggleShowLegend}
                map={map} 
				mask={false}
				closable={true}
				footer={null}
				className={`legend-sidebar`}
                title="Legenda"
				bodyStyle={{overflowY: 'scroll'}}
            >
                <div className="sidebar-content" style={{fontSize:'20px'}}>
                    <h3 style={{opacity:"0.6",borderRadius:"15px",textAlign:"center",marginTop:"3px",marginBottom:"6px",background:"black",padding:"5px"}}> <img src={ponuda} className="legend-title-icon"  />Ponuda</h3>                  
                    <div><img src={obrnuti_u} className="legend-icon"  />Obrnuti U stalak za bicikle - "klamerica"</div>
                    <div><img src={niski_spiralni} className="legend-icon"/>Niski spiralni stalak za bicikle – niska "spirala"</div>
					<div><img src={niski_resetkasti}  className="legend-icon"/>Niski rešetkasti stalak za bicikle - niska "rešetka"</div>
                    <div><img src={skloniste} className="legend-icon"/>Ormar za pohranu bicikala – "bike box"</div>
					<div><img src={parkirna_konstrukcija}  className="legend-icon"/>Parkirna konstrukcija u razinama</div>
                    <div><img src={punionica_za_e} className="legend-icon"/>Punionica za e-bicikle</div>
					<div><img src={stupicasti}  className="legend-icon"/>Stupčasti stalak za bicikle – "stup"</div>
                    <div><img src={utor} className="legend-icon"/>"Utor" za kotač bicikla</div>
					<div><img src={visoki_resetkasti} className="legend-icon"/>Visoki rešetkasti stalak za bicikle – visoka "rešetka"</div>
                    <div><img src={visoki_spiralni} className="legend-icon"/>Visoki spiralni stalak za bicikle – visoka "spirala"</div>
					<div><img src={zidni} className="legend-icon"/>"Zidni nosač"</div>
                    <div><img src={valoviti} className="legend-icon"/>Valoviti stalak za bicikle – "val"</div>
					<div><img src={stalak_za_romobile} className="legend-icon"/>Stalak za romobile</div>
					<h3 style={{opacity:"0.6",borderRadius:"15px",textAlign:"center",marginTop:"3px",marginBottom:"6px",background:"black",padding:"5px"}}> <img src={potraznja} className="legend-title-icon"  />Potražnja</h3>          
					<div><img src={bicikl_potraznja}  className="legend-icon"/>Bicikli potražnja</div>
                    <div><img src={romobil_potraznja} className="legend-icon"/>Romobili potražnja</div>
					</div>
            </Modal>
				
			<Drawer
                title={bicycleParkingSpotTitle}
                width="600px"
				destroyOnClose={true}
				className={`bicycleParkingSpot-modal`}
				placement="right"	
                closable={true}
				mask={false}
				onClose={toggleShowBicycleParkingSpotInfo}
                onCancel={toggleShowBicycleParkingSpotInfo}
                visible={showBicycleParkingVisible}
				footer={null}
            >
				
				<BicycleParkingSpotInfo 
					bicycleParkingSpot={selectedBicycleParkingSpot}
					onDataUpdate={refreshAllSources}
					showImages={handleShowImage} 
					setShowBicycleParkingVisible={setShowBicycleParkingVisible}
					onEditLocation={manuallySetLocation}
				/>
			</Drawer>

		
			
			<Modal
				centered 
				width="70%"
				wrapClassName="modal-station-image-viewer"
				visible={showImageVisible}
				onOk={() => setShowImageVisible(!showImageVisible)}
                onCancel={() => setShowImageVisible(!showImageVisible)}
				footer={null}
            >
				 {currentImages && currentImages.length > 0 && (
					<Carousel autoplay effect="fade" dotPosition='top'>
						{currentImages.map(image => {
							return (
								<img src={image.photoLocation || image} width="100%" />
							)
						})}
					</Carousel>
				)}
            </Modal>
			
			<Modal
				centered 
				width="90%"
				wrapClassName="modal-print-viewer"
				visible={showPrintVisible}
				okText="Isprintaj"
				onOk={handlePrintSubmit}
                onCancel={togglePrintVisible}
            >
				<img crossOrigin="anonymous" src={imageToPrint} width="100%" />
            </Modal>

			
			

			<Modal
				centered 
				width="70%"
				visible={administrationInterfaceModalVisible}
				onCancel={toggleShowAdministrationInterfaceModal}
				className={"administrationInterfaceModal"}
				footer={false}
			>
					<AdministrationInterface></AdministrationInterface>
				
			</Modal>	
			
			<AnalyticsDashboard 
				show={showAnalyticsDashboard}
				onClose={toggleShowAnalyticsDashboard}
			/>

			<Modal
				centered 
				width="70%"
				visible={rulebookVisible}
				onCancel={toggleShowRulebook}
				className={"rulebookModal"}
				footer={false}
			>
				<Rulebook/>
			</Modal>

			<Modal
                map={map} 
				mask={false}
				closable={true}
				className={`legend-sidebar`}
                title="Semafor"
				bodyStyle={{overflowY: 'scroll'}}
				
				visible={surveyAnsweredCountVisible}
				onCancel={toggleShowSurveyAnsweredCount}
				//className={"survey-answered-count"}
				footer={false}
			>
				<SurveyAnsweredCount></SurveyAnsweredCount>
			</Modal>
					


		
			<UpdatePassword

				visible={authenticationService.getUser()?.details?.firstLogin}
			
			></UpdatePassword>			
				

				{showLocator.current && (
					<>
				<div className="locator" ><i className={`ri-map-pin-fill ${mapMoving && "locator-moving" || ""}`}></i></div>
				<div style={{position:'fixed',bottom:'30px',left:'45vw'}}>
					<NavbarButton style={{color:'red'}}icon="ri-close-line" onClick={closeGeomUpdateWindow}/>
					<NavbarButton style={{color:'green',marginLeft:'30px'}}icon="ri-check-line" onClick={updateGeom} />
				</div>
				</>
			)}
        </>
		
    );
}
